import Clarity from './clarity.column-name.constants';
import CoolantSample from './coolant-sample.column-name.constants';
import Comment from './comment.column-name.constants';
import Company from './company.column-name.constants';
import Customer from './customer.column-name.constants';
import Fluid from './fluid.column-name.constants';
import FluidManufacturer from './fluid-manufacturer.column-name.constants';
import FluidBrand from './fluid-brand.column-name.constants';
import FluidClass from './fluid-class.column-name.constants';
import FluidWeight from './fluid-weight.column-name.constants';
import FluidBaselineSample from './fluid-baseline-sample.column-name.constants';
import FluidAction from './fluid-action.column-name.constants';
import ManufacturerModel from './manufacturer-model.column-name.constants';
import OilResult from './oil-result.column-name.constants';
import OilSample from './oil-sample.column-name.constants';
import Precipitate from './precipitate.column-name.constants';
import Unit from './unit.column-name.constants';
import UnitOfMeasure from './unit-of-measure.column-name.constants';
import UnitType from './unit-type.column-name.constants';
import User from './user.column-name.constants';

export default {
  Clarity,
  CoolantSample,
  Comment,
  Company,
  Customer,
  Fluid,
  FluidManufacturer,
  FluidBrand,
  FluidClass,
  FluidWeight,
  FluidBaselineSample,
  FluidAction,
  ManufacturerModel,
  OilResult,
  OilSample,
  Precipitate,
  Unit,
  UnitOfMeasure,
  UnitType,
  User,
  buttons: { field: '', title: '', sortable: false },
  createdBy: { field: 'createdBy' },
  isActive: { field: 'isActive', title: 'Active?' },
  isDeleted: { field: 'isDeleted', title: 'Deleted?' },
  modifiedBy: { field: 'modifiedBy' }
};
